/**
 * Quiz API Handler
 * Handles quiz fetching, answer submission, and session management
 */

(function() {
  'use strict';

  const API_BASE = 'https://app.bepivotal.co.uk/api/v1';
  const API_KEY = '7a2918b913ae5bf9e75103ea994aba1df813abd1b185354f3b69304acfd4a17d';
  const QUIZ_SLUG = 'find-your-perfect-flooring';

  // Generate or retrieve session token
  function getSessionToken() {
    let token = localStorage.getItem('quiz_session_token');
    if (!token) {
      token = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('quiz_session_token', token);
    }
    return token;
  }

  // Get customer ID if logged in
  function getCustomerId() {
    return window.shopifyCustomerId || null;
  }

  // Quiz API
  const QuizAPI = {
    /**
     * Fetch quiz (uses hardcoded slug)
     * @returns {Promise<Object>}
     */
    async fetch() {
      try {
        const response = await fetch(`${API_BASE}/quizzes/${QUIZ_SLUG}`, {
          method: 'GET',
          headers: {
            'X-Storefront-Key': API_KEY,
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message || 'Failed to fetch quiz');
        }
        
        return data;
      } catch (error) {
        console.error('Quiz fetch error:', error);
        throw error;
      }
    },

    /**
     * Submit quiz answers (uses hardcoded slug)
     * @param {Array} answers - Array of {question_id, answer_ids}
     * @returns {Promise<Object>}
     */
    async submit(answers) {
      try {
        const payload = {
          answers: answers,
          session_token: getSessionToken()
        };

        const customerId = getCustomerId();
        if (customerId) {
          payload.customer_id = customerId;
        }

        const url = `${API_BASE}/quizzes/${QUIZ_SLUG}/submit`;
        
        console.log('Quiz Submit - URL:', url);
        console.log('Quiz Submit - Payload:', payload);
        console.log('Quiz Submit - Answers:', answers);

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'X-Storefront-Key': API_KEY,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        console.log('Quiz Submit - Response Status:', response.status);
        console.log('Quiz Submit - Response Headers:', Object.fromEntries(response.headers.entries()));

        // Try to parse JSON, but handle HTML error pages
        let data;
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          data = await response.json();
        } else {
          const text = await response.text();
          console.error('Quiz Submit - Non-JSON Response:', text.substring(0, 500));
          throw new Error(`Server returned ${response.status} ${response.statusText}. Expected JSON but got ${contentType || 'unknown'}`);
        }
        
        if (!response.ok) {
          console.error('Quiz Submit - Error Response:', data);
          throw new Error(data.message || data.error || `Failed to submit quiz: ${response.status} ${response.statusText}`);
        }

        return data;
      } catch (error) {
        console.error('Quiz submit error:', error);
        // Provide more helpful error message
        if (error.message.includes('405')) {
          throw new Error('API endpoint does not accept POST requests. Please check the API configuration.');
        }
        throw error;
      }
    }
  };

  // Expose API globally
  window.quizAPI = QuizAPI;
})();
